import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { PatientGroupEvent } from './patient_group_events';

@Injectable({ providedIn: 'root' })
export class PatientGroupEventProvider extends DomainEventProvider<PatientGroupEvent> {}
